export default __webpack_public_path__ + "static/1107-27e98f869093376f3ee93bbed68bb2b7.gif";